import { useEffect, useState } from "react";
import {
  loginUserToken,
  getCurrentUser,
  logoutUserRequest,
} from "../requests/user";

const useUser = () => {
  const [currentUser, setCurrentUser] = useState(null);

  const refetchCurrentUser = async () => {
    const userObject = await getCurrentUser();
    if (userObject && userObject.email) {
      setCurrentUser({ ...userObject, isAuth: true });
    } else {
      setCurrentUser({ isAuth: false });
    }
  };

  const loginUser = ({ credential }) => {
    loginUserToken({ tokenLogin: credential }).then((userObject) => {
      setCurrentUser({
        ...userObject,
        credentialToken: credential,
        isAuth: true,
      });
    });
  };

  const logoutUser = () => {
    logoutUserRequest().then(setCurrentUser({ isAuth: false }));
  };

  useEffect(() => {
    getCurrentUser().then((userObject) => {
      if (userObject && userObject.email) {
        setCurrentUser({ ...userObject, isAuth: true });
      } else {
        setCurrentUser({ isAuth: false });
      }
    });
  }, []);

  return {
    currentUser,
    loginUser,
    logoutUser,
    refetchCurrentUser,
  };
};

export default useUser;
